import { __generator } from "tslib";
/**
 * KEEP IT DUMB AND SIMPLE
 */
import { call, put, select, takeEvery } from 'redux-saga/effects';
import { request } from '../xhr';
import { makeXHRCall, setIsLoading, storeResult } from './actionCreators';
import { getIsLoading } from './selectors';
import { getFakeResponse } from './fakeResponses';
export function makeXHRCallHandler(_a) {
    var isLoading, result;
    var _b = _a.payload, endpoint = _b.endpoint, method = _b.method, params = _b.params, data = _b.data, onComplete = _b.onComplete, onSuccess = _b.onSuccess, onError = _b.onError;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, select(getIsLoading, endpoint)];
            case 1:
                isLoading = _c.sent();
                if (isLoading) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, put(setIsLoading(endpoint))];
            case 2:
                _c.sent();
                return [4 /*yield*/, call(request, {
                        method: method,
                        url: endpoint,
                        params: params,
                        data: data,
                    }, getFakeResponse(endpoint))];
            case 3:
                result = _c.sent();
                return [4 /*yield*/, put(storeResult({ endpoint: endpoint, result: result }))];
            case 4:
                _c.sent();
                if (!result || result.error) {
                    onError && onError(result);
                }
                else {
                    onSuccess && onSuccess();
                }
                onComplete && onComplete();
                return [2 /*return*/];
        }
    });
}
export default function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeEvery(makeXHRCall, makeXHRCallHandler)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map